import styled from "styled-components";

export const Root = styled.div`
  width: 100%;
`;

// BV parity: the iframe plugin's label section is a bare h4 with no padding —
// only the theme's h4 rules (margin-top 0.5em etc.) size it. The shared
// LabelSection's padding-bottom: 10px steals that height from the flex iframe
// below it (the container height is fixed), vertically compressing responsive
// embeds. The first paragraph rule sits at the plugin's cascade position: it
// beats UA defaults but loses to theme selectors like ".component-label p"
// (which also outrank the plugin in BV). The boosted margin-top matches the
// one place class specificity decides in BV: the plugin's ".component-label
// > p { margin: 0 }" blocks the theme's "body p" margin-top, but that theme
// rule is rescoped under #viewer-express-container here and needs an ID to
// re-block.
export const IframeLabelSection = styled.h4`
  & > .component-label > p,
  & > .component-title > p {
    display: inline-block;
    margin: 0;
  }

  #viewer-express-container && > .component-label > p,
  #viewer-express-container && > .component-title > p {
    margin-top: 0;
  }
`;

export const Container = styled.div<{ $heightPx: number; $isMobile?: boolean }>`
  width: 100%;
  max-width: 100%;
  min-width: 0;
  box-sizing: border-box;
  height: ${(p) => (p.$isMobile ? "auto" : `${p.$heightPx}px`)};
  display: flex;
  flex-direction: column;
  font-family: var(--body-font, Arial, sans-serif);
  color: var(--text-color, rgba(0, 0, 0, 0.87));

  /* BV parity: the container also carries BV's "plugin-iframe" class so the
     theme's iframe-big sizing rules (".example_2.iframe-big .plugin-iframe
     { width: 920px }", the Sidebar_*Aside variants, every breakpoint) size it
     like BV's plugin iframe; they outrank ".iframe-big div.iframe-container"
     (1100px), which can never match in BV — .iframe-big (screen frame) and
     .iframe-container (component plugin frame) live in different documents
     there. Both rule sets also offset the box (left: -10em, right: 5em
     !important, ...); in BV the plugin iframe computes position: static, so
     every offset is inert and the frame stays anchored at the column,
     overhanging to the right. Mirror that instead of cancelling each offset.
     The stage clips the overhang (see RceStage) like BV's frame edge does. */
  .iframe-big &&,
  #viewer-express-container .iframe-big && {
    position: static;
  }
`;

export const ThumbnailWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  border-radius: 4px;
`;

export const ThumbnailContainer = styled.div`
  cursor: pointer;
  position: relative;
  width: 100%;
`;

export const ThumbnailImage = styled.img`
  pointer-events: none;
  width: 100%;
  max-width: 100%;
  height: auto;
  display: block;
  -webkit-user-drag: none;
`;

export const LinkIcon = styled.span`
  position: absolute;
  cursor: pointer;
  bottom: 5px;
  right: 10px;

  svg {
    display: block;
  }
`;

// BV parity: the plugin leaves the figure at UA defaults (margin: 1em 40px)
// and only zeroes margin-left. The 40px right margin is load-bearing — it
// narrows the caption/credit text so lines wrap where BV wraps them — and in
// the fixed-height flex container the 1em top/bottom margins take part in
// sizing the iframe above, so inventing tighter margins here resizes embeds.
export const FigureBlock = styled.figure`
  margin: 1em 40px 1em 0;
`;

// BV parity: bare figcaption / caption / credit — the plugin ships no CSS for
// them, so only the theme styles them (e.g. ".component-credit p" font-size
// 0.95em of the page base). Local font-size/color overrides here change the
// metrics the theme rules compound against and diverge from BV.
export const FigCaption = styled.figcaption``;

export const CaptionText = styled.div``;

export const CreditText = styled.div``;

export const StyledIframe = styled.iframe`
  flex: 1 1 auto;
  display: block;
  border: none;
  margin-top: 15px;
`;
